/*global
    jQuery, aap
*/
(function ($) {

    'use strict';

    var $form = $('#NlSubmitForm'),
        $email = $('#emailAddress'),
        isValid = false,
        hasError = aap.querystring().error === '1',
        allGood = aap.querystring().emailid;


    var checkForm = function (e) {
        e.preventDefault();

        // validity is checked on blur event, so trigger blur
        $email.trigger('blur');

        isValid = !$email.hasClass('error');

        if (isValid) {
            $form.off('submit').trigger('submit');
        }

    };


    if(hasError && !allGood) {
        //charity engine querystring check and display
        $email.addClass('error').val(aap.querystring().emailAddress);
        $form.find('span.error').text('invalid');
        //scroll back down to form in footer
        $('html,body').css({
            scrollTop: $form.offset().top
        });
    }

    if(allGood && !hasError) {
        $('#newsletter_label').text('Thanks! You are signed up');
        $('html,body').css({
            scrollTop: $form.offset().top
        });
    }

    //newsletter signup validation
    $email.on('blur', function() { aap.checkField(this); });
    $form.on('submit', checkForm);

}(jQuery));
